import { render, staticRenderFns } from "./DecorationPage.vue?vue&type=template&id=a3f8d3bc&scoped=true&"
import script from "./DecorationPage.vue?vue&type=script&lang=js&"
export * from "./DecorationPage.vue?vue&type=script&lang=js&"
import style0 from "./DecorationPage.vue?vue&type=style&index=0&id=a3f8d3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f8d3bc",
  null
  
)

export default component.exports